import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import {
  PricingHero,
  PricingCardsGrid,
  FeatureComparisonTable,
  PricingFAQ,
} from '@/components/pricing';

const Pricing = () => {
  return (
    <div className="min-h-screen w-full flex flex-col bg-background">
      <Navbar />

      <main className="flex-grow">
        {/* Hero Section */}
        <PricingHero />

        {/* Pricing Cards with Billing Toggle */}
        <PricingCardsGrid />

        {/* Feature Comparison Table */}
        <FeatureComparisonTable />

        {/* FAQ Section */}
        <PricingFAQ />
      </main>

      <Footer />
    </div>
  );
};

export default Pricing;
